// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__zZvpM","col":"Table_col__2q9br","fulfillmentStatus":"Table_fulfillmentStatus__2PA_e","emailCol":"Table_emailCol__1mMWq"};